export enum Variant {
    MasterData = 'Master Data',
    GbbPublic = 'GBB Public'
}

export enum FileUploadVariants {
    MasterData = 'master',
    Public = 'public'
}